import { useState } from 'react';

const noop = () => {};

export default function useConfirmAction() {
    const [openDialog, setOpenDialog] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState(() => noop);

    const openConfirmDialog = (action) => {
        setOpenDialog(true);
        setActionToConfirm(() => action);
    };

    const closeConfirmDialog = () => {
        setOpenDialog(false);
        setActionToConfirm(() => noop);
    };

    return {
        openDialog,
        actionToConfirm,
        openConfirmDialog,
        closeConfirmDialog,
    };
}
